"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Card = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _CardHeader = _interopRequireDefault(require("../CardHeader"));

var _CardMedia = _interopRequireDefault(require("../CardMedia"));

var _CardActions = _interopRequireDefault(require("../CardActions"));

var _CardContent = _interopRequireDefault(require("../CardContent"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Card = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Card, _Component);

  var _super = _createSuper(Card);

  function Card() {
    var _this;

    (0, _classCallCheck2.default)(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasProps", function (props) {
      return props.some(function (p) {
        return typeof _this.props[p] !== "undefined";
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderIfHasProps", function (props, component) {
      return _this.hasProps(props) ? component() : "";
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          id = _this$props.id,
          raised = _this$props.raised,
          image = _this$props.image,
          imageHeight = _this$props.imageHeight,
          title = _this$props.title,
          subheader = _this$props.subheader,
          avatar = _this$props.avatar,
          content = _this$props.content,
          disableFooterSpacing = _this$props.disableFooterSpacing,
          footer = _this$props.footer,
          cardHeaderProps = _this$props.cardHeaderProps,
          cardMediaProps = _this$props.cardMediaProps,
          cardContentProps = _this$props.cardContentProps,
          cardActionsProps = _this$props.cardActionsProps,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "id", "raised", "image", "imageHeight", "title", "subheader", "avatar", "content", "disableFooterSpacing", "footer", "cardHeaderProps", "cardMediaProps", "cardContentProps", "cardActionsProps"]); // build the card components:

      var cardMedia = _this.renderIfHasProps(["image", "imageHeight"], function () {
        return /*#__PURE__*/_react.default.createElement(_CardMedia.default, (0, _extends2.default)({}, cardMediaProps, {
          image: image,
          height: imageHeight
        }));
      });

      var cardHeader = _this.renderIfHasProps(["title", "subheader", "avatar"], function () {
        var muiProps = _objectSpread({
          title: title,
          subheader: subheader
        }, cardHeaderProps);

        if (avatar !== undefined) {
          muiProps.avatar = /*#__PURE__*/_react.default.createElement(_Avatar.default, avatar);
        }

        return /*#__PURE__*/_react.default.createElement(_CardHeader.default, muiProps);
      });

      var cardContent = _this.renderIfHasProps(["content"], function () {
        return /*#__PURE__*/_react.default.createElement(_CardContent.default, cardContentProps, content);
      });

      var cardFooter = _this.renderIfHasProps(["footer"], function () {
        return /*#__PURE__*/_react.default.createElement(_CardActions.default, (0, _extends2.default)({}, cardActionsProps, {
          disableSpacing: disableFooterSpacing
        }), footer);
      });

      return /*#__PURE__*/_react.default.createElement(_Card.default, (0, _extends2.default)({
        id: id,
        raised: raised,
        className: (0, _classnames.default)("prmbl-card", className)
      }, otherProps), cardHeader, cardMedia, cardContent, cardFooter);
    });
    return _this;
  }

  return Card;
}(_react.Component);

exports.Card = Card;
(0, _defineProperty2.default)(Card, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   *  If `true`, the card will use raised styling.
   */
  raised: _propTypes.default.bool,

  /**
   * The content of the card
   */
  content: _propTypes.default.node,

  /**
   *  The subheader to use on the card header
   */
  subheader: _propTypes.default.node,

  /**
   *  The Avatar for the Card Header.
   *
   */
  avatar: _propTypes.default.shape({
    /**
     * The html id
     */
    id: _propTypes.default.string.isRequired,

    /**
     * Used in combination with `src` or `srcSet` to provide an alt attribute for the rendered `img` element.
     */
    alt: _propTypes.default.string,

    /**
     * Used to render icon or text elements inside the Avatar. `src` and `alt` props will not be used and no `img` will be rendered by default. This can be an element, or just a string.
     */
    children: _propTypes.default.node,

    /**
     * @ignore
     */
    className: _propTypes.default.string,

    /**
     * Event handler for onBlur
     */
    onBlur: _propTypes.default.func,

    /**
     * Event handler for onFocus
     */
    onFocus: _propTypes.default.func,

    /**
     * Event handler for onMouseLeave
     */
    onMouseLeave: _propTypes.default.func,

    /**
     * Event handler for onMouseOver
     */
    onMouseOver: _propTypes.default.func,

    /**
     * Event handler for onTouchEnd
     */
    onTouchEnd: _propTypes.default.func,

    /**
     * Event handler for onTouchStart
     */
    onTouchStart: _propTypes.default.func,

    /**
     * The `sizes` attribute for the `img` element.
     */
    sizes: _propTypes.default.string,

    /**
     * The `src` attribute for the `img` element.
     */
    src: _propTypes.default.string,

    /**
     * The `srcSet` attribute for the `img` element.
     */
    srcSet: _propTypes.default.string
  }),

  /**
   *  The title to use on the card header
   */
  title: _propTypes.default.node,

  /**
   * The footer content of the card
   */
  footer: _propTypes.default.node,

  /**
   *  If `true`, the card footer does not have additional margin.
   */
  disableFooterSpacing: _propTypes.default.bool,

  /**
   * If provided, the card will have an image shown at the top
   */
  image: _propTypes.default.string,

  /**
   * The height of a provided image
   */
  imageHeight: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Props to pass on to the CardAction component
   */
  cardHeaderProps: _propTypes.default.object,

  /**
   * Props to pass on to the CardMedia component
   */
  cardMediaProps: _propTypes.default.object,

  /**
   * Props to pass on to the CardContent component
   */
  cardContentProps: _propTypes.default.object,

  /**
   * Props to pass on to the CardActions component
   */
  cardActionsProps: _propTypes.default.object
});
(0, _defineProperty2.default)(Card, "defaultProps", {
  className: ""
});
var _default = Card;
exports.default = _default;